import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Mapper } from '@services/generics/data.mapper';
import { MapperService } from '@services/mapper.service';
var MailService = /** @class */ (function (_super) {
    tslib_1.__extends(MailService, _super);
    function MailService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        _this.mapper = MapperService.smtpParametersMap;
        return _this;
    }
    MailService.prototype.send = function (sendTo, smtpSettings) {
        var smtpTestParameters = {
            sendTo: sendTo,
            smtpSettingModel: this._toPoco(smtpSettings),
        };
        return this._http.post('odata/Settings/UiPath.Server.Configuration.OData.VerifySmtpSetting', JSON.stringify(smtpTestParameters));
    };
    return MailService;
}(Mapper));
export { MailService };
